/**
 * @generated SignedSource<<fed037311e7e524ebc2d1a6e98e4db4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentMethodContent_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCheckWrapper_item" | "CheckoutWireTransferWrapper_item">;
  readonly " $fragmentType": "CheckoutPaymentMethodContent_item";
};
export type CheckoutPaymentMethodContent_item$key = {
  readonly " $data"?: CheckoutPaymentMethodContent_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentMethodContent_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentMethodContent_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferWrapper_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCheckWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "507e45b7c2a0d4e14c1e12fad622462d";

export default node;
